import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated"; 
import { LANDING_TYPE_CONTENT } from "../interfaces";
import { getID } from "src/libs/utilities";

export default function thumbnail_tile(): any[] {
    return [
        {
          "id": getID("thumbnail-tile"),
          "type": LANDING_TYPE_CONTENT.THUMBNAIL_TILE,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "gap": 0,
          "images": [
            "https://i.pinimg.com/736x/c7/f4/ff/c7f4ff53678689dad78ecd30756ea685.jpg",
            "https://i.pinimg.com/1200x/81/24/3e/81243e4285d92c54064461587fba29c7.jpg",
            "https://i.pinimg.com/1200x/55/01/c3/5501c30406822c0ba0531182b44caf2b.jpg",
            "https://i.pinimg.com/1200x/93/01/47/93014789681bbd03fea01d9e21f87b87.jpg",
            "https://i.pinimg.com/736x/96/ad/d0/96add073eaf18c968f643fe3e09da660.jpg",
            "https://i.pinimg.com/1200x/cd/d5/e5/cdd5e560574434057b7d6d6271a6993a.jpg",
            "https://i.pinimg.com/1200x/60/a3/df/60a3df8f4a7c942d20a9c84cb1a994b7.jpg",
            "https://i.pinimg.com/736x/95/2a/cd/952acd3c180ba3d184cbea1a5f60b8fa.jpg",
            "https://i.pinimg.com/1200x/26/28/bd/2628bd7e49a7fc8b8ddad0b3ceebcbfe.jpg",
            "https://i.pinimg.com/736x/e7/a7/c9/e7a7c9f0c1900346917ad240c653b040.jpg",
            "https://i.pinimg.com/1200x/b9/9b/86/b99b8632fd707bcf6a1ecb4b7a824fcd.jpg",
            "https://i.pinimg.com/736x/9b/0e/e7/9b0ee7874076e6f9229f314bf5c50d9d.jpg"
          ],
          defaultTitle: "Плитка без швов"
        },
        {
          "id": getID("thumbnail-tile"),
          "type": LANDING_TYPE_CONTENT.THUMBNAIL_TILE,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "gap": 40,
          "images": [
            "https://i.pinimg.com/736x/c7/f4/ff/c7f4ff53678689dad78ecd30756ea685.jpg",
            "https://i.pinimg.com/1200x/81/24/3e/81243e4285d92c54064461587fba29c7.jpg",
            "https://i.pinimg.com/1200x/55/01/c3/5501c30406822c0ba0531182b44caf2b.jpg",
            "https://i.pinimg.com/1200x/93/01/47/93014789681bbd03fea01d9e21f87b87.jpg",
            "https://i.pinimg.com/736x/96/ad/d0/96add073eaf18c968f643fe3e09da660.jpg",
            "https://i.pinimg.com/1200x/cd/d5/e5/cdd5e560574434057b7d6d6271a6993a.jpg",
            "https://i.pinimg.com/1200x/60/a3/df/60a3df8f4a7c942d20a9c84cb1a994b7.jpg",
            "https://i.pinimg.com/736x/95/2a/cd/952acd3c180ba3d184cbea1a5f60b8fa.jpg",
            "https://i.pinimg.com/1200x/26/28/bd/2628bd7e49a7fc8b8ddad0b3ceebcbfe.jpg",
            "https://i.pinimg.com/736x/e7/a7/c9/e7a7c9f0c1900346917ad240c653b040.jpg",
            "https://i.pinimg.com/1200x/b9/9b/86/b99b8632fd707bcf6a1ecb4b7a824fcd.jpg",
            "https://i.pinimg.com/736x/9b/0e/e7/9b0ee7874076e6f9229f314bf5c50d9d.jpg"
          ],
          defaultTitle: "Плитка с широким швом"
        },
    ]
}